// The string included at the start of user-oriented console logs for
// local event logging, to make filtering console logs easier.
export const ConsoleKey = 'ANALYTICS';

// The local storage key for a user to enable local logging on their specific device
export const LocalStorageEnableKey = 'show_analytics_events';
